// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export var Extauth2ValidateStatus;
(function (Extauth2ValidateStatus) {
    Extauth2ValidateStatus[Extauth2ValidateStatus["Valid"] = 0] = "Valid";
    Extauth2ValidateStatus[Extauth2ValidateStatus["UserFound"] = 1] = "UserFound";
    Extauth2ValidateStatus[Extauth2ValidateStatus["Invalid"] = 2] = "Invalid";
    Extauth2ValidateStatus[Extauth2ValidateStatus["UserNotFound"] = 3] = "UserNotFound";
    Extauth2ValidateStatus[Extauth2ValidateStatus["AccountDisabled"] = 4] = "AccountDisabled";
    Extauth2ValidateStatus[Extauth2ValidateStatus["AccountLocked"] = 5] = "AccountLocked";
    Extauth2ValidateStatus[Extauth2ValidateStatus["PasswordExpired"] = 6] = "PasswordExpired";
    Extauth2ValidateStatus[Extauth2ValidateStatus["ServerError"] = 7] = "ServerError";
    Extauth2ValidateStatus[Extauth2ValidateStatus["UserMustChangePassword"] = 8] = "UserMustChangePassword";
})(Extauth2ValidateStatus || (Extauth2ValidateStatus = {}));
//# sourceMappingURL=extauth2ValidateStatus.js.map